import React, { Component } from "react";
import Page from '../../Page';
import Intro from '../../components/Intro/Intro.js';
import Quote from '../../components/Quote/Quote.js';
import TextFullImage from '../../components/TextFullImage/TextFullImage.js';
import fullimageImage from '../../img/B26A9857-min.jpg';
import quoteImage from '../../img/B26A9861-min.jpg';
import data from '../../components/magazine.json';
import DocumentMeta from "react-document-meta";
import PageNumber from "../../components/PageNumber/PageNumber";
import Share from "../../components/Share/Share";
import MetaTags from "react-meta-tags";

const introtekst = data.magazine.pages[11]["intro-text"];

const quote = data.magazine.pages[11].quote;
const author = data.magazine.pages[11].author;
const website = data.magazine.pages[11].website;

const title =  data.magazine.pages[11].title;
const paragraphs1 = data.magazine.pages[11]["paragraphs-first-part"];

class Thirteenthpage extends Component {
  componentDidMount(){
    const prevLink = '/appart-me/editie-9/space32-volgens-bart-jansen-het-is-voor-mij-een-denktank-van-twee-bedrijven-die-elkaar-aanvullen';
    const nextLink = '/appart-me/editie-9/';
    const prevPossible = true;
    const nextPossible = true;
    const isScrollable = true;
    this.props.updatelinks(prevLink, nextLink, prevPossible, nextPossible, isScrollable);
  }

  render() {
    console.log(data);
    const meta = {
      title: 'Appart Me | Editie 9 | ' + author + ' | ' + data.magazine.pages[11]["intro-title"] ,
    };
    return (
      <Page>
        <MetaTags>
          <title>{ meta.title }</title>
          <meta name="description" content="Designer aan het woord: De gedachte achter het logo van SPACE32" />
          <meta name="og:title" content="Designer aan het woord: De gedachte achter het logo van SPACE32" />
          <meta name="og:description" content="Designer aan het woord: De gedachte achter het logo van SPACE32" />
          <meta name="og:image" content={"https://appart.nl/" + fullimageImage} />
          <meta name="twitter:image" content={"https://appart.nl/" + fullimageImage} />
        </MetaTags>
        <Intro title={data.magazine.pages[11]["intro-title"]} subtitle={data.magazine.pages[11]["intro-sub-title"]} content={introtekst} background={fullimageImage}/>
        <TextFullImage title={title} paragraphs={paragraphs1} image={fullimageImage} alt="papegaai"/>
        <Share />
        <Quote quote={quote} author={author} website={website} classes='quote-block' image={quoteImage}/>
        <PageNumber pageNumber={14} />
      </Page>
    )
  }
}

export default Thirteenthpage;
